module.exports = __webpack_public_path__ + "cf60f4a0b8200950a5d05af527619d2f.jpg";